import React from "react";

import { Box } from "@mui/material";
import image1 from "../../assets/Taiwan.jpg";
import image2 from "../../assets/Tapuchips.jpg";
import image3 from "../../assets/Walkers.jpg";
import image4 from "../../assets/Lays.jpg";
import image5 from "../../assets/Thailand.jpg";
import image6 from "../../assets/SaudiArabia.jpg";

// Add remaining images as necessary

const imageArray = [image1, image2, image3, image4, image5, image6];

export default function ContainerImages2() {
  return (
    <div className="px-14">
      <Box
        sx={{
          width: "100%",
          display: "inline-flex", // Inline flex display
          justifyContent: "space-between", // Center content horizontally
          alignItems: "flex-start", // Align content to the top
          gap: {
            xs: "24px", // Adjust gap for smaller screens
            lg: "84px", // Adjust gap for larger screens
          },
          paddingX: "42px",
          opacity: 0.3,
        }}
      >
        {imageArray.map((item, index) => (
          <Box
            key={index}
            sx={{
              width: "90px", // Width of the image box
              height: "92.222px", // Height of the image box
              backgroundImage: `url(${item})`, // Set the image URL
              backgroundColor: "lightgray", // Fallback color
              backgroundSize: "cover", // Ensure the image covers the container (or use "contain" depending on your preference)
              backgroundPosition: "center", // Center the image
              backgroundRepeat: "no-repeat", // Prevent the image from repeating
            }}
          />
        ))}
      </Box>
    </div>
  );
}
